var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["core-country-interstitial-copy.j2"] = require( "core-country-interstitial-copy.j2" );
dependencies["core-country-interstitial-buttons.j2"] = require( "core-country-interstitial-buttons.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/core-country-interstitial.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 60, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"displayCountrySwitchInterstitialAsModal"]));
frame.set("displayCountrySwitchInterstitialAsModal", t_1, true);
if(frame.topLevel) {
context.setVariable("displayCountrySwitchInterstitialAsModal", t_1);
}
if(frame.topLevel) {
context.addExport("displayCountrySwitchInterstitialAsModal", t_1);
}
output += "\n\n<div class=\"s-interstitial-banner dom-country-interstitial\">";
if(runtime.contextOrFrameLookup(context, frame, "countryCodeInterstitial") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteSwitchingActive") && (!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "countryCodeInterstitial")),"isModal"))) {
output += "<div class=\"c-interstitial\">\n            ";
var t_2;
t_2 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "countryCodeInterstitial")),"isModal");
frame.set("isModal", t_2, true);
if(frame.topLevel) {
context.setVariable("isModal", t_2);
}
if(frame.topLevel) {
context.addExport("isModal", t_2);
}
output += "\n\n            <div class=\"o-row c-interstitial__outer\" data-qa-country-interstitial>\n\n                ";
env.getTemplate("core-country-interstitial-copy.j2", false, "core/templates/core-country-interstitial.j2", null, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
t_3.render(context.getVariables(), frame, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
output += t_4
output += "\n\n                ";
env.getTemplate("core-country-interstitial-buttons.j2", false, "core/templates/core-country-interstitial.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n\n            </div>\n\n        </div>";
})})})});
}
output += "</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/core-country-interstitial.j2"] , dependencies)